import React, { Component } from "react";
import PropTypes from 'prop-types';

import { Modal } from "semantic-ui-react";
import SvgSpinner from '../SvgSpinner/SvgSpinner'

class ModalWindow extends Component {
  static propTypes = {
    heading: PropTypes.string,
    confirmText: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    cancelText: PropTypes.string,
    modal: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  static defaultProps = {
    heading: '',
    cancelText: 'Отмена',
  }

  render() {
    const { heading, confirmText, cancelText, modal, onSubmit, onCancel } = this.props;

    return (
      <Modal open={modal.isOpen}>
        <button type="button" className="btn-close modal-close" onClick={() => onCancel()} />
        {(heading.length !== 0) ? (
          <h2>{heading}</h2>
        ) : (
          <h2>Если вы покинете страницу,<br />все несохраненные изменения будут потеряны.</h2>
        )}
        <Modal.Actions>
          <button type="button" className="btn-cancel" onClick={() => onCancel()}>{cancelText}</button>
          <button
              type="button"
              className="btn btn-green btn-spinner"
              disabled={!!this.props.loading}
              onClick={() => onSubmit()}
          >
            {this.props.loading ? (<SvgSpinner/>) : confirmText}
          </button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ModalWindow;
